export interface DeleteDefaultParameterInterLibraryLoanRequest {
  id: string
  revision: number
}

export function DeleteDefaultParameterInterLibraryLoanRequestToJSON(
  value: DeleteDefaultParameterInterLibraryLoanRequest
): any {
  return {
    id: value.id ? value.id : undefined,
    revision: value.revision ? value.revision : undefined
  }
}
